import React, { useState, useEffect } from "react";
import HomeHeader from "./HomeHeader";
import About from "./About";
import HomeSlide from "./HomeSlide";
import AdmissionSession from "./AdmissionSession";
import Card from "./Card";
import DivisionPage from "./DivisionPage";
import Footer from "./Footer";
import api from "../api/api";
import TotalStudentAndApplySection from "./TotalStudentAndApplySection";



import "./Styles/home.css";

const Home = () => {


  return (
    <div>
      <div className="headerderty">
        <HomeHeader />
      </div>

<div>
     <Card />
</div>
 
     <div className="homeeeSlide">
        <About />
      </div>


<div>
    <Footer />
</div>


    
    </div>
  );
};

export default Home;
